const EMAIL_REGEX =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

const PASSWORD_REGEX = /((?=.{8,})(?=.*[A-Z]))/;

export const CF_REGEX = /^(?:[A-Z]{6}[0-9]{2}[A-EHLMPRST][0-9]{2}[A-Z][0-9]{3}[A-Z]|[0-9]{11})$/i;

export const validateTextExists = (name: string) => name.length >= 1;

export const validatePassword = (password: string) => PASSWORD_REGEX.test(password);

export const validateEmail = (email: string) => EMAIL_REGEX.test(email);

export const validateCodiceFiscale = (cf: string) => CF_REGEX.test(cf);

export const validatePostalCode = (value: string) => Number.isInteger(Number(value)) && value.length === 5;
